import { render, staticRenderFns } from "./basicInfoApproval.vue?vue&type=template&id=14920c02&"
import script from "./basicInfoApproval.vue?vue&type=script&lang=js&"
export * from "./basicInfoApproval.vue?vue&type=script&lang=js&"
import style0 from "./basicInfoApproval.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports